"use strict";
exports.__esModule = true;
exports.toString = void 0;
var toString = function (point) { return "SRID=".concat(point.srs, ";POINT(").concat(point.x, " ").concat(point.y, ")"); };
exports.toString = toString;
//# sourceMappingURL=toString.js.map